/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./carousel-item2.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./carousel-item2.component";
var styles_CarouselItem2Component = [i0.styles];
var RenderType_CarouselItem2Component = i1.ɵcrt({ encapsulation: 0, styles: styles_CarouselItem2Component, data: {} });
export { RenderType_CarouselItem2Component as RenderType_CarouselItem2Component };
export function View_CarouselItem2Component_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "carousel-item-wrapper"]], null, null, null, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_CarouselItem2Component_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-carousel-item2", [], null, null, null, View_CarouselItem2Component_0, RenderType_CarouselItem2Component)), i1.ɵdid(1, 49152, null, 0, i2.CarouselItem2Component, [i1.ElementRef, i1.Renderer2], null, null)], null, null); }
var CarouselItem2ComponentNgFactory = i1.ɵccf("app-carousel-item2", i2.CarouselItem2Component, View_CarouselItem2Component_Host_0, {}, {}, ["*"]);
export { CarouselItem2ComponentNgFactory as CarouselItem2ComponentNgFactory };
